import { render, staticRenderFns } from "./program-importer-page.vue?vue&type=template&id=d4ef951e&"
import script from "./program-importer-page.vue?vue&type=script&lang=js&"
export * from "./program-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports